import { Loader } from "components/Common/Loader";
import Render from "components/Common/Render";
import React from "react";

interface IButtonProps {
  label: string | React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: "primary" | "secondary";
  disabled?: boolean;
  customClass?: string;
  rightIcon?: React.ReactNode;
  leftIcon?: React.ReactNode;
  loading?: boolean;
  form?: string;
}

const Button: React.FC<IButtonProps> = ({
  label,
  onClick,
  disabled,
  type = "button",
  variant = "primary",
  loading = false,
  customClass,
  rightIcon,
  leftIcon,
  form,
}) => {
  const primaryButtonStyle = "text-white bg-royalBlue";
  const secondaryButtonStyle = "text-royalBlue bg-white border border-royalBlue";
  const disabledStyle = "opacity-50 cursor-not-allowed";

  const buttonClass =
    variant === "primary" ? primaryButtonStyle : secondaryButtonStyle;

  const isDisabled = disabled || loading;

  const handleClick = () => {
    if (isDisabled) return;
    if (type === "submit") {
      // Allow normal form submission to happen
      return;
    }
    onClick?.();
  };

  return (
    <button
      form={form}
      type={type}
      onClick={handleClick}
      disabled={isDisabled}
      className={`${buttonClass} font-medium rounded h-10 px-4 text-sm flex items-center justify-center gap-2 ${customClass} ${
        isDisabled ? disabledStyle : ""
      }`}
    >
      <div className="flex flex-row gap-2 justify-center items-center">
        <Render when={!!leftIcon}>
          <span>{leftIcon}</span>
        </Render>
        <Render when={loading} elseRender={<>{label}</>}>
          <Loader size={4} color="transparent" />
        </Render>
        <Render when={!!rightIcon}>
          <span>{rightIcon}</span>
        </Render>
      </div>
    </button>
  );
};

export default Button;
